import { useState } from 'react';

import { GetWorkOrderFilesMediaPayloadModel } from '@lichtblick/types';
import { downloadFileExtend } from '@lichtblick/utils';

import { Button } from '../Button';

export const DownloadAction = ({ row }: { row: { original: GetWorkOrderFilesMediaPayloadModel } }) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Button
      isDisabled={isLoading}
      label={isLoading ? 'Loading...' : 'Download'}
      onClick={async () => {
        setIsLoading(true);

        try {
          if (!row.original.uri) {
            return;
          }

          await downloadFileExtend(row.original.uri, row.original.fileName ?? '');
        } finally {
          setIsLoading(false);
        }
      }}
    />
  );
};
